export const SnapshotLocations = {
    KITCHEN_PLAN: 'kitchen-plan',
    FRONT_ELEVATION: 'front-elevation',
    LEFT_ELEVATION: 'left-elevation',
    RIGHT_ELEVATION: 'right-elevation',
    TOP_LEFT_VIEW: 'top-left-view',
    TOP_RIGHT_VIEW: 'top-right-view',
};
